<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import {
  collegeComputed,
  collegeListMethod,
  authComputed,
  siteListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'College List',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Table,
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      platformId: 'All',
      collegelist: {},
      allCollegeList: {},
      siteconfiglist: [],
      fields: [
        {
          value: 'name',
          text: 'Name',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'collegeCode',
          text: 'College Code',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        {
          key: 'name',
          label: 'Name',
          colType: 'default',
        },
        {
          key: 'collegeCode',
          label: 'College Code',
          colType: 'default',
        },
      ],
    }
  },
  computed: {
    ...collegeComputed,
    ...authComputed,
  },
  mounted() {
    this.getListOfColleges()
    this.getListOfPlatform()
  },
  methods: {
    ...collegeListMethod,
    ...siteListMethod,

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    // Get list of all colleges
    getListOfColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({
        filter,
      })
        .then((collegeList) => {
          this.collegelist = JSON.parse(JSON.stringify(collegeList))
          this.allCollegeList = JSON.parse(JSON.stringify(this.collegeList))
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    getColleges() {
      if (this.platformId !== 'All') {
        let listitems = []
        this.allCollegeList.docs.forEach((element) => {
          if (element.platform_id === Number(this.platformId)) {
            listitems.push(element)
          }
        })
        this.collegelist.docs = listitems
      } else {
        this.collegelist.docs = this.allCollegeList.docs
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <router-link
              v-if="role === 'admin'"
              tag="button"
              to="/college-add"
              class="btn btn-info mb-2"
            >
              <i class="ti-plus"></i><span> Add College</span>
            </router-link>
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getColleges"
              ></b-form-select>
            </b-form-group>
            <Table
              :fields="fields"
              :items="collegelist ? collegelist.docs : []"
              :editbtn="true"
              :viewbtn="true"
              :deletebtn="true"
              :college="true"
              :display-fields="displayFields"
            >
            </Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
